import { ControlNetModel } from '../interface/ControlNetModel.ts';

class GetControlNetModelsResponse {
	controlNetModels: ControlNetModel[];

	constructor(controlNetModelsData: ControlNetModel[]) {
		this.controlNetModels = controlNetModelsData;
	}

	formatControlNetModelsData() {
		if (Array.isArray(this.controlNetModels)) {
			return this.controlNetModels.map((controlNetModel) => ({
				id: controlNetModel.id,
				baseModel: controlNetModel.base_model,
				imageUrl: controlNetModel.image_url,
				model: controlNetModel.model,
				module: controlNetModel.module,
				name: controlNetModel.name,
				popularity: controlNetModel.popularity,
			}));
		}
		return [];
	}
}

export default GetControlNetModelsResponse;
